









































































































































































































































































































import { Component, Vue, Watch, Mixins } from 'vue-property-decorator'
import TaskApi from '@/api/task'
import InvestigateApi from '@/api/investigate'
import BillApi from '@/api/bill'
import PageLayout from '@/components/page/PageLayout.vue'
import { TOKEN } from '@/store/mutation-types'
import isEmpty from 'lodash/isEmpty'
import cloneDeep from 'lodash/cloneDeep'
import { columns } from './config'
import listMixins from '@/mixins/list'
import { download } from '@/utils/util'
import LawsuitApi from '@/api/lawsuit'
import {
	DAI_QUE_REN_LAW,
	DAI_JIE_DAN,
	ZUO_YE_ZHONG,
	DAI_ZHONG_SHEN,
	YI_WAN_CHENG,
	DAI_DIAO_DU,
	YI_QU_XIAO,
	YI_GUAN_DAN,
} from '@/web-task/config.ts'
// 待确认-待接单-作业中-待终审-已完成-待调度-已取消-已关单
const statusOrder = [
	DAI_QUE_REN_LAW,
	DAI_JIE_DAN,
	ZUO_YE_ZHONG,
	DAI_ZHONG_SHEN,
	YI_WAN_CHENG,
	DAI_DIAO_DU,
	YI_QU_XIAO,
	YI_GUAN_DAN,
]

@Component({
	name: 'lawsuitTaskList',
	components: {
		PageLayout,
	},
})
export default class TasksList extends Mixins(listMixins) {
	private columns: object = columns
	private data: any[] = []
	private visible: boolean = false

	private timer: any = ''
	private exportingList: boolean = false
	private exportingTask: boolean = false

	private get orderStatusList() {
		let res = [{ key: '', value: '全部' }]
		return res.concat(
			statusOrder.map((status: any) => {
				return {
					key: status,
					value:
						this.$store.state.setting.orderStatusMap[status] ||
						this.$store.state.setting.lawOrderStatusMap[status],
				}
			})
		)
	}

	private extraBtn(orderStatus: string) {
		let res = ''
		switch (orderStatus) {
			case DAI_ZHONG_SHEN:
				res = '确认资料'
				break
			case DAI_QUE_REN_LAW:
				res = '确认律师'
				break
			case YI_GUAN_DAN:
				res = '重新发送'
				break
		}
		return res
	}

	private onClickExtraBtn(action: any, orderStatus: string) {
		if (orderStatus === YI_GUAN_DAN) {
			this.resend(action.orderId)
		} else {
			this.$router.push(this.taskDetailPwd(action))
		}
	}

	private taskDetailPwd(action: any) {
		return `/lawsuit/taskDetail/${action.orderId}`
	}

	private resend(orderId: string) {
		this.$confirm({
			title: '提示',
			content: '确认重新发送吗 ?',
			onOk: () => {
				return TaskApi.resendOrder(orderId).then((res: any) => {
					this.$message.success('发送成功')
					this.getList()
				})
			},
		})
	}

	public created() {
		this.$store.dispatch('setting/initAreas')
	}

	private exportList() {
		this.exportingList = true
		LawsuitApi.exportList(this.getForm())
			.then((res: any) => {
				const blob: any = new Blob([res.data])
				download(blob, res.filename)
			})
			.finally(() => {
				this.exportingList = false
			})
	}

	public getList() {
		return LawsuitApi.getList(this.getForm()).then((res: any) => {
			this.data = res.data.retList
			this.total = res.data.count
			this.resetSelected()
		})
	}

	public activated() {
		this.$store.dispatch('setting/initCompanyTree').then((res: any) => {
			this.setCompanyAsTree()
		})
		this.getList()
	}

	private getForm() {
		const form: any = this.getSearchValues()
		form.createTime =
			form.rangeTime &&
			form.rangeTime[0] &&
			form.rangeTime[0].format('YYYY-MM-DD')
		form.endTime =
			form.rangeTime &&
			form.rangeTime[1] &&
			form.rangeTime[1].format('YYYY-MM-DD')
		delete form.rangeTime

		let temp =
			typeof form.company.value === 'string'
				? form.company.value.trim()
				: form.company.value
		if (temp || temp === 0) {
			form.companyId = temp
		}
		delete form.company

		return form
	}

	private checkSelected() {
		if (!this.selected.length) {
			this.$message.error('请选择订单')
			return false
		}
		return true
	}
}
